import { useTenantStore } from '../stores/tenantStore'
import { objectStore } from './objectStore'

const LOCAL_STORAGE_KEYS = [
  'rita-dashboard-active-tab',
  'rita-master-data-active-tab',
  'master-data-view-mode',
  'rita-selected-object',
  'selectedNodeId',
  'cacheStats',
  'rita_api_metrics',
  'rita_web_vitals',
  'connectionLogs_showExceptionsOnly',
  'rita-notification-preferences',
  'rita-preferences',
  'rita-preference-templates',
]

const SESSION_STORAGE_KEYS = [
  'integrationManagementNavigation',
  'referenceDataFilter',
  'code_verifier',
]

export function clearAppStateStorage() {
  LOCAL_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key))
  SESSION_STORAGE_KEYS.forEach((key) => sessionStorage.removeItem(key))
  useTenantStore.setState({ selectedTenant: null })
  objectStore.setObject(null)
}

function clearAuthStorage() {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
}

export function clearFullSessionStorage() {
  clearAppStateStorage()
  clearAuthStorage()
}
